import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useInvalidateCache } from "~hooks/useInvalidateCache.ts";
import type { UpdateEntity } from "~pages/Entities/types/upsertEntity.ts";
import type { EntityResponse } from "~types/entity.ts";

export const useUpdateEntity = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();
  const { mutateAsync: invalidateCache } = useInvalidateCache();

  return useMutation<EntityResponse, Error, UpdateEntity>({
    mutationFn: async ({ entityId, ...body }) =>
      await request<EntityResponse>(`${sport}/o/${organizationId}/entities/${entityId}`, {
        method: "PUT",
        body,
      }),
    onSuccess: async (_response, { entityId }) => {
      await Promise.all([
        invalidateCache(),
        queryClient.invalidateQueries({ queryKey: ["entities", sport, organizationId] }),
        queryClient.invalidateQueries({ queryKey: ["entity", sport, organizationId, entityId] }),
      ]);
    },
  });
};
